import { Text } from '@zillow/constellation-10';
import { Flex } from '@zillow/constellation';
import { StyledTextButton } from './StyledComponents';
import { IconFilter } from '../Icons';

const FiltersPopoverSkeleton = (): JSX.Element => {
  return (
    <StyledTextButton
      disabled={true}
      icon={
        <Flex display="flex" alignItems="center">
          <IconFilter />
        </Flex>
      }
    >
      <Text>Filters</Text>
    </StyledTextButton>
  );
};

export default FiltersPopoverSkeleton;
